import {
  createSlice,
  createAsyncThunk
} from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
  loading: false,
  data: [],
  error: ''
};

export const fetch = createAsyncThunk('revisionList/fetch',
  async ({accessToken}) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + '/revision-list', {
      headers: {
        Authorization: "Bearer " + accessToken
      }
    });

    return response.data;
  })

const revisionListSlice = createSlice({
  name: 'revisionList',
  initialState,
  reducers: {},
  extraReducers: {
    [fetch.pending]: (state, action) => {
      state.loading = true
      state.error = ''
      state.data = []
    },
    [fetch.fulfilled]: (state, action) => {
      state.loading = false
      state.data = action.payload
    },
    [fetch.rejected]: (state, action) => {
      state.loading = false
      state.error = action.error.message
    },
  },
})

export default revisionListSlice.reducer

export const selectAll = (state) => {
  return state.revisionList
}
